// ┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┓
// ┃ ██████ ██████ ██████       █      █      █      █      █ █▄  ▀███ █       ┃
// ┃ ▄▄▄▄▄█ █▄▄▄▄▄ ▄▄▄▄▄█  ▀▀▀▀▀█▀▀▀▀▀ █ ▀▀▀▀▀█ ████████▌▐███ ███▄  ▀█ █ ▀▀▀▀▀ ┃
// ┃ █▀▀▀▀▀ █▀▀▀▀▀ █▀██▀▀ ▄▄▄▄▄ █ ▄▄▄▄▄█ ▄▄▄▄▄█ ████████▌▐███ █████▄   █ ▄▄▄▄▄ ┃
// ┃ █      ██████ █  ▀█▄       █ ██████      █      ███▌▐███ ███████▄ █       ┃
// ┣━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┫
// ┃ Copyright (c) 2017, the Perspective Authors.                              ┃
// ┃ ╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌ ┃
// ┃ This file is part of the Perspective library, distributed under the terms ┃
// ┃ of the [Apache License 2.0](https://www.apache.org/licenses/LICENSE-2.0). ┃
// ┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┛

import type { ViewConfig } from "@perspective-dev/client";

/**
 * Detail payload for the `perspective-click` CustomEvent dispatched on
 * the `<perspective-viewer>` host when the user clicks a chart glyph.
 * Shape matches the equivalent type in `@perspective-dev/viewer-datagrid`
 * so consumers can listen to either plugin uniformly.
 */
export interface PerspectiveClickDetail {
    /**
     * Source-view row data — keys are column names, values are scalar
     * cell values. Empty `{}` when the click hit a non-leaf aggregate
     * (e.g. a treemap branch).
     */
    row: Record<string, unknown>;

    /**
     * Aggregate column(s) the click targeted. Single-entry for series /
     * heatmap / tree charts; multi-entry would only appear for plugins
     * that surface multiple measures per glyph (none today).
     */
    column_names: string[];

    /**
     * Pre-built `viewer.restore({ filter })` patch — concatenates the
     * group_by and split_by pivot values at the click target as
     * `[<col>, "==", <value>]` clauses.
     */
    config: Partial<ViewConfig>;
}

export { PerspectiveSelectDetail } from "@perspective-dev/viewer/src/ts/extensions.js";
